<template>
    <label :for="labelFor" class="block text-normal font-medium leading-5 text-gray-700"><slot /> <span v-if="required"
        class="text-xs text-red-400">●</span></label>
</template>

<script>
    export default {
        name: "FormLabel",
        props: {
            labelFor: String,
            text: String,
            required: {type: Boolean, default: false}
        }
    }
</script>
